import * as React from 'react';
import './backupMode.scss';
import { useActions } from '../viewActions';
import { useSelector } from '../../../utils/useSelector';
import { WarningDiamond } from 'rcd-cpp-ui/ui/icon/WarningDiamond';
import { Buttons, Cancel, Continue, Secondary } from 'rcd-cpp-ui/ui/button';
import { Modal } from 'rcd-cpp-ui/ui/modal/Modal';
import { View } from '../../../types/View';
import { UserGroup } from '../../Icon/icon';
import { showBackupMode } from '../../../utils';

const RoleDisplayName = {
  1: 'Team Manager',
  2: 'Internal Reviewer',
  4: 'Mandatory Reviewer',
  8: 'Vendor Lead',
  9: 'KI Leader',
  10: 'Chief of Research',
  11: 'Lead Author'
};

export const BackupMode = () => {
  const view = useSelector(s => s.view?.selected);
  const backingUpFor = useSelector(s => s.view?.backingUpFor);
  const { setBackingUpFor } = useActions();
  if (!showBackupMode(view) || !backingUpFor || !backingUpFor?.roleIds?.length)
    return null;
  const backupRoles = backingUpFor.roleIds
    .map(id => {
      return RoleDisplayName[id];
    })
    .filter(x => x)
    .sort((a, b) => a.localeCompare(b))
    .join(', ');
  return (
    <div className="backup-mode">
      <div>
        <span>
          <WarningDiamond />
        </span>
        <span>Backup Mode</span>
        <span>|</span>
        <span>
          Backing up for {backingUpFor.name} for {backupRoles}
        </span>
      </div>
      <div>
        <Secondary onClick={() => setBackingUpFor(undefined)}>
          <UserGroup /> Exit Backup Mode
        </Secondary>
      </div>
    </div>
  );
};

export const BackupModeButton = () => {
  const view = useSelector(s => s.view?.selected);
  const empCd = useSelector(s => s.app?.user?.employeeId);
  const backingUpFor = useSelector(s => s.view?.backingUpFor);
  const getAPI = useSelector(s => s.app?.elFn?.getAPI);
  const [showModal, setShowModal] = React.useState(false);
  const [backups, setBackups] = React.useState<View.BackingUpFor[]>(null);
  const [selected, setSelected] = React.useState<View.BackingUpFor>(null);
  const closeModal = () => setShowModal(false);
  const { setBackingUpFor } = useActions();
  React.useEffect(() => {
    if (backingUpFor === undefined) setShowModal(false);
  }, [backingUpFor]);
  React.useEffect(() => {
    if (showModal && backups?.length) setSelected(backups[0]);
  }, [showModal, backups]);
  const showButton = showBackupMode(view) && !backingUpFor;
  React.useEffect(() => {
    if (showButton && getAPI && empCd) {
      const { getUserBackups } = getAPI();
      getUserBackups(empCd).then(backups => {
        setBackups(backups);
      });
    }
  }, [empCd, showButton]);
  if (!showButton || !backups?.length) return null;
  return (
    <div className="backup-mode-button">
      <Secondary onClick={() => setShowModal(true)}>
        <UserGroup /> Backup Mode
      </Secondary>
      <Modal
        id="backupModal"
        header="Backing up for"
        height="auto"
        width="auto"
        onClose={closeModal}
        hide={!showModal}
      >
        <div className="backup-text">
          Select who you want to back up from your options below.
        </div>
        <div className="backup-modal scrollable">
          {backups.map(b => (
            <div className="form-check" key={b.empCd}>
              <input
                className="form-check-input"
                type="radio"
                name="backup"
                id={'backup' + b.empCd}
                checked={selected?.empCd == b.empCd}
                onChange={() => setSelected(b)}
              />
              <label className="form-check-label" htmlFor={'backup' + b.empCd}>
                {b.name}
              </label>
            </div>
          ))}
        </div>
        <Buttons>
          <Cancel onClick={closeModal} />
          <Continue onClick={() => setBackingUpFor(selected)} />
        </Buttons>
      </Modal>
    </div>
  );
};
